import React from 'react';
import PropTypes from 'prop-types';

import styles from './SharedHostingFeatures.scss';

const SharedHostingFeatures = ({mainFeatures, isMain, pullTop, additionalFeatureText, additionalFeatureOnClick}) => {

	return (
	  <ul
		className={`${isMain ? styles.mainChars : styles.secondaryCharts} ${pullTop === true ? styles.pullTop : undefined}`}>
		  {mainFeatures.map(function (feature, index) {
			  return <li key={index}>{feature}</li>;
		  })}
		  {!!additionalFeatureOnClick && !!additionalFeatureText && (
			<li><a onClick={additionalFeatureOnClick}>{additionalFeatureText}</a></li>
		  )}
	  </ul>
	);
};
SharedHostingFeatures.defaultProps = {
	isMain: true
};

//
SharedHostingFeatures.propTypes = {
	mainFeatures: PropTypes.arrayOf(PropTypes.string).isRequired,
	isMain: PropTypes.bool,
	pullTop: PropTypes.bool,
	additionalFeatureText: PropTypes.string,
	additionalFeatureOnClick: PropTypes.func
};

export default SharedHostingFeatures;